/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

export function initTouchDevice() {
  document.addEventListener('touchstart', () => document.documentElement.classList.add('is-touch'));
}

export function isTouchDevice() {
  return document.documentElement.classList.contains('is-touch');
}

export function prepositionsNbsp() {
  const tags = document.querySelector('.main').querySelectorAll('h1, h2, h3, h4, h5, h6, p, li');
  tags.forEach(tag => {
    tag.innerHTML = tag.innerHTML.replaceAll(/( |&nbsp;)([kosuvz]|do|ke|na|od|ku|po|se|ve|za|ze|bez|buď|čím|nad|pod|pro|před|přes|při|tím|[ai]|ač|až|ba|či|že|leč|než|když|vždyť) /g, "$1$2&nbsp;");
  })
}
